import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

export interface AuthState {
  accessToken: string | null;
  isAuthenticated: boolean;
  tokenExpiration: number | null;
  loading: boolean;
  role: string | undefined;
  lastError?: {
    type: "FORBIDDEN" | "UNAUTHORIZED";
    timestamp: number;
    path?: string;
  };
}

const initialState: AuthState = {
  accessToken: null,
  isAuthenticated: false,
  tokenExpiration: null,
  loading: false,
  role: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
  reducers: {
    setAccessToken: (
      state,
      action: PayloadAction<{
        token: string;
        expiresIn: number;
      }>
    ) => {
      state.accessToken = action.payload.token;
      state.tokenExpiration = Date.now() + action.payload.expiresIn * 1000;
      state.isAuthenticated =
        action.payload.token !== "" && !!action.payload.token;
    },
    clearAccessToken: (state) => {
      state.accessToken = null;
      state.tokenExpiration = null;
      state.isAuthenticated = false;
      state.tokenExpiration = null;
      state.role = undefined;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setAuthError: (
      state,
      action: PayloadAction<{
        type: "FORBIDDEN" | "UNAUTHORIZED";
        path?: string;
      }>
    ) => {
      state.lastError = {
        type: action.payload.type,
        timestamp: Date.now(),
        path: action.payload.path,
      };
    },
    clearAuthError: (state) => {
      state.lastError = undefined;
    },
  },
});

export const {
  setAccessToken,
  clearAccessToken,
  setLoading,
  setAuthError,
  clearAuthError,
} = authSlice.actions;
export default authSlice.reducer;
